module.exports = __webpack_public_path__ + "img/0010.ed5c4ef4.jpg";